import React from 'react'
import { BorderColor, Button, Container, Icon, Spacer, Text, TextColor } from 'roadie-ui'

export type OnboardingCardProps = {
  icon: React.ReactElement
  iconColor: TextColor
  iconBackgroundColor: BorderColor
  title: string
  description: string
  link: string
}

const OnboardingCard: React.FC<OnboardingCardProps> = (props) => {
  return (
    <Container.Grid $padding="2.4rem" $gridTemplateColumns="5rem 1fr max-content" $alignItems="center">
      <Container.Position $position="relative" $width="5rem" $height="5rem">
        <Container.Position $position="absolute" $top="0" $bottom="0" $left="0" $right="0">
          <Container.Base $borderRadius="100%" $backgroundColor={props.iconBackgroundColor} $height="100%" />
        </Container.Position>
        <Container.Position
          $color={props.iconColor}
          $position="absolute"
          $top="0"
          $left="0"
          $right="0"
          $padding=".75rem"
        >
          {props.icon}
        </Container.Position>
      </Container.Position>
      <Container.Base $textAlign="left" $padding="0 1rem 0 3rem">
        <Text.H6 $fontWeight="400" $color="neutral-black">
          {props.title}
        </Text.H6>
        <Spacer $height="0.5rem" />
        <Text.Body2>{props.description}</Text.Body2>
      </Container.Base>
      <Button.A.Tertiary href={props.link}>
        <Container.Grid $justifyItems="end">
          <Icon.ChevronRight $color="neutral-base" $width="2.4rem" $height="2.4rem" />
        </Container.Grid>
      </Button.A.Tertiary>
    </Container.Grid>
  )
}

export default OnboardingCard
